import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Rate } from '../classes';
import {SettingsmanagerService} from './settingsmanager.service';

@Injectable({
  providedIn: 'root'
})
export class RateService {

  private _url: string;

  constructor(
    private _http: HttpClient,
    private settingsManager: SettingsmanagerService
  ) {
    this._url =  this.settingsManager.getBaseWsUrl();
  }

  public listAll() : Observable<Rate[]> {
    return this._http.get<Rate[]>(`${this._url}/rate`).pipe(
      map(obj => obj.map(x => new Rate(x)))
    );
  }

  public getOne(id: number): Observable<Rate> {
    return this._http.get<Rate>(`${this._url}/rate/${id}`).pipe(
      map(obj => new Rate(obj))
    );
  }

  public update(id:number , obj: Partial<Rate>): Observable<Rate> {
    return this._http.patch<Rate>(`${this._url}/rate/${id}`, obj).pipe(map(obj => new Rate(obj)));
  }

  public create(obj: Rate): Observable<Rate> {
    return this._http.post<Rate>(`${this._url}/rate`, obj).pipe(map(obj => new Rate(obj)));
  }

  public delete(id: number): Observable<void> {
    return this._http.delete<void>(`${this._url}/rate/${id}`);
  }

  }


